import { Component, OnInit, ViewChild } from '@angular/core';
import { PrimeNgTablePageEvent, ScrBaseComponent } from 'src/app/components/base.component';
import { TableColumn } from 'src/app/models/table-columns';
import { IndustryReportsService, InMarketMonitoringFilter, VmAuditSummary } from 'src/app/services/industry-reports.service';

import { Router } from '@angular/router';
import { ShortCodesService } from 'src/app/services/shortcodes.service';
import { IuiMessagesComponent } from 'src/app/shared/messages/messages.component';
import { Table } from 'primeng/table';
import { ScrBaseService } from '../../../../services';

@Component({
  selector: 'app-in-market-monitoring',
  templateUrl: './in-market-monitoring.component.html',
  styleUrls: ['./in-market-monitoring.component.scss']
})
export class InMarketMonitoringComponent extends ScrBaseComponent implements OnInit {
  @ViewChild('message', { static: false }) message!: IuiMessagesComponent;
  @ViewChild('MarketMonitoring', { static: false }) marketMonitoringTable!: Table;
  today = new Date();
  shortCodeOrFormId = "1";
  auditTypes = [
    { name: 'CTIA Standard Rate Advertisement', id: 0 },
    { name: 'CTIA Standard Rate Message Flow', id: 1 },
    { name: 'CTIA Standard Rate Severity 0 Audit', id: 2 },
    { name: 'Fraud Alert', id: 3 },
    { name: 'Unsolicited Message Alert', id: 4 }
  ];

  tableColumn: TableColumn[] = [
    { field: 'formId' },
    { field: 'noticeDate' },
    { field: 'shortCode' },
    { field: 'overallSeverity' },
    { field: 'status' },
    { field: 'auditType' },
    { field: 'cureDate' },
    { field: 'sourceType' }
  ];

  statuses = [
    { id: 'Published', name: 'Published' },
    { id: 'Closed', name: 'Closed' }
  ];

  filter: InMarketMonitoringFilter = {
    status: this.statuses.map(item => item.id),
    auditType: this.auditTypes.map(item => item.name),
    page: 1
  };

  results: VmAuditSummary[] = [];
  showData = false;
  totalRecords = 0;
  rowsInPage = 0;
  currentPage = 0;
  minEndDate = new Date();

  constructor(private service: IndustryReportsService, private scService: ShortCodesService, private router: Router) {
    super();
  }

  ngOnInit(): void {
    this.localizeTableColumns(this.tableColumn);
  }

  onReset(): void {
    this.message.clearAll();
    this.shortCodeOrFormId = "1"; //1 = Short Code, 2 = Form ID
    this.filter = {
      status: this.statuses.map(item => item.id),
      auditType: this.auditTypes.map(item => item.name),
      page: 1
    };
  }

  onSubmit(): void {
    this.clearErrors();

    switch (this.shortCodeOrFormId) {

      case "1": //Short Code
        if (this.filter.startDate && !this.filter.endDate) {
          this.displayLocalizedError("scr.endDateRequired");
          return;
        } else if (this.filter.startDate && this.filter.endDate && this.filter.startDate > this.filter.endDate) {
          this.displayLocalizedError('scr.enddatestartdate.invalid');
          return;
        } else {
          this.filter.formId = undefined;
          this.fetchInMktMonitoringReportData(1);
        }
        break;
      case "2": //Form  ID
        if (this.filter.formId === undefined || this.filter.formId === null || this.filter.formId.length < 1) {
          this.displayLocalizedError('scr.formIDRequired');
          return;
        } else {
          this.filter.startDate = undefined;
          this.filter.endDate = undefined;
          this.filter.status = undefined;
          this.filter.auditType = undefined;
          this.filter.shortCode = undefined;
          this.fetchInMktMonitoringReportData(1);
        }
        break;
    }
  }

  fetchInMktMonitoringReportData(pagenumber: number) {

    this.message.clearAll();

    if (this.filter.startDate && this.filter.endDate && this.filter.startDate > this.filter.endDate) {
      this.displayLocalizedError('scr.enddatestartdate.invalid');
      return;
    } else if (this.filter.shortCode && ScrBaseService.isInvalidShortCode(this.filter.shortCode)) {
      this.displayLocalizedError('scr.shortcode.invalid');
      return;
    }

    if (this.filter.startDate && !this.filter.endDate) {
      this.filter.endDate = new Date('2100-01-01');
    }
    if (this.filter.endDate && !this.filter.startDate) {
      this.filter.startDate = new Date('2019-01-01');
    }
    this.filter.page = pagenumber;
    this.results = [];
    this.observe(this.service.fetchInMarketReports(this.filter), res => {
      this.totalRecords = res.data.totalCount;
      this.rowsInPage = res.data.limit;
      this.results = res.data.audits || [];
      this.showData = true;
      if (pagenumber === 1 && this.marketMonitoringTable) {
        this.marketMonitoringTable._first = 0;
      }
      return false;
    });
  }

  paginateReports(event: PrimeNgTablePageEvent) {
    this.currentPage = (event.first ?? 0) / (event.rows ?? 0) + 1;
    this.fetchInMktMonitoringReportData(this.currentPage);
  }

  downloadReport(report: VmAuditSummary) {

    this.observeDownloadOrAny(this.service.downloadReport(report.auditId), res => {
      this.service.processBlobResponseDownload(res, 'application/pdf');
    });
  }

  openLookup(report: VmAuditSummary) {
    this.router.navigate(['/dashboard', { outlets: { 'navbar-tab': ['code-management', { outlets: { 'code-management-tab': ['code-lookup'] } }] } }], { state: { shortCode: report.shortCode } });
  }
}
